import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      fontWeight: 600,
      fontSize: '18pt',
      color: theme.palette.common.white,
      margin: theme.spacing(3, 0, 2, 0),
      padding: theme.spacing(0.5),
      display: 'flex',
      width: '100%',

      '&.shortTerm, &.midTerm, &.longTerm': {
        borderBottomStyle: 'solid',
        borderBottomWidth: '3px',
      },

      '@media print': {
        '.pageBreak + &': {
          marginTop: 0,
        },
      },
      '& span': {
        paddingLeft: theme.spacing(1),
        fontSize: '12pt',
        verticalAlign: 'bottom',
      },
      '&.numbered': {
        counterIncrement: 'section',
        counterReset: 'subSection',
        '&:before': {
          content: 'counter(section)".\u00A0\u00A0"',
        },
      },
      '&.tight': {
        marginTop: theme.spacing(2),
      },
    },
  }),
);

export default useStyles;
